/**
 * StoreLocator Component
 *
 * This component allows users to find their nearest store by entering
 * a town or postcode. It includes a search input field and a button
 * to initiate the search, redirecting users to the find-stores page.
 *
 * Features:
 * - Responsive design that adjusts for different screen sizes.
 * - Interactive elements including a search input and button for user interaction.
 *
 * Functionality:
 * - The user enters a town or postcode, which updates the component's
 *   state. Upon submitting the form, the user is redirected to the
 *   find-stores page.
 * - The component includes an icon and descriptive text to guide the
 *   user in finding their local store.
 *
 */

import React, { useState } from 'react';
import Typography from 'components/commercetools-ui/atoms/typography';
import { MapPinIcon } from '@heroicons/react/24/outline';
import Input from 'components/commercetools-ui/atoms/input';
import Button from 'components/commercetools-ui/atoms/button';
import Map from 'public/images/store-locator.png';
import Image from 'frontastic/lib/image';

const StoreLocator = () => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    if (searchQuery) {
      // Redirect to the find-stores page with the search query
      // window.location.href = `/find-stores?zipcity=${searchQuery}`;
      window.location.href = `/find-stores?q=${searchQuery}`;
    }
  };

  return (
    <section className="grid-row screen grid gap-10">
      <div className="flex justify-center px-5 text-center">
        <Typography as="h2" className="text-21 font-bold uppercase leading-[23px] md:text-36 md:leading-[33px]">
          Find Your Nearest Store
        </Typography>
      </div>
      <div className="relative mt-20 h-[250px] w-full">
        {/* insted of image needs to change as map BG*/}
        <Image src={Map} alt="Background Image" className="absolute inset-0 h-full w-full object-cover filter" />
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-center py-2 text-center">
          <MapPinIcon className="h-34 w-34 text-white" />
          <Typography className="my-5 text-26 font-semibold leading-7 text-white">Find your local store</Typography>
          <Typography className="px-10 text-18 leading-5 text-white">
            85 stores nationwide so there is always one near you
          </Typography>
          <div className="w-full max-w-[240px] pt-10">
            <form className="mb-7 ms-16 mt-21" onSubmit={handleSearch}>
              <div className="relative h-[50px]">
                <Input
                  className="border-none"
                  onChange={(e) => setSearchQuery(e.target.value)}
                  name="town-or-postcode"
                  value={searchQuery}
                  placeholder="Town or postcode"
                  isFooter={true}
                  labelPosition="inline"
                  isValid={searchQuery.length > 0}
                />
                <div className="absolute right-0 top-0">
                  <Button type="submit" className="rounded-l-none font-semibold uppercase" variant="primary">
                    Find
                  </Button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StoreLocator;
